import { useScriptEventPage } from '#imports'
import { useTracer } from '../composables/useTracer'

export default defineNuxtPlugin(() => {
  // track all page views
  const tracer = useTracer()
  useScriptEventPage(() => tracer.pageView())
})
